const wowApp = require('angular').module('wowApp.shop');

wowApp.service('SignupService', ['$rootScope', '$q', 'Restangular', 'LoginService', 'ShopperService', 'AtmService', 'AtmLocalService', require('./signup-service')]);
wowApp.service('AgeCalculatorService', [require('./age-calculator-service')]);
wowApp.service('PasswordStrengthService', [require('./password-strength-service')]);

wowApp.directive('wowSignupPanel', ['GlobalHeaderPanelService', require('./signup-panel-directive')]);
wowApp.directive('wowSignupForm', ['$state', 'SignupService', '$sce', 'AgeCalculatorService', 'CurrentUserService', 'SettingsService', 'GoogleCaptchaV3Service', 'PasswordValidationService', '$rootScope', require('./signup-form-directive')]);
wowApp.directive('wowSignupNavigation', [require('./signup-navigation-directive')]);
wowApp.directive('wowGuestSignupDelivery', ['AddressService', 'BwsNotificationService', 'ServerErrorFiller', '$rootScope', '$templateCache', 'CurrentUserService', 'StorePickerService', 'CheckoutService', 'AgeCalculatorService', 'AtmService', 'ShopperService', 'DeliveryService', require('./guestsignupdelivery/guest-signup-delivery-directive')]);
wowApp.directive('wowPasswordStrength', ['PasswordStrengthService', require('./password-strength-directive')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/index.js
 **/